export function isCommunity() {
    return window.location.pathname.includes('/communit') && !window.location.pathname.includes('/community/app');
}
